import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isObjectNullOrEmpty} from "../../../../Utilities/Types/objectUtilities";

export const getFullName = (item: Record<string, unknown>) => {
    if(isNullOrUndefined(item) || isObjectNullOrEmpty(item))
        return "";

    return `${item.firstName} ${item.middleName ?? ""} ${item.lastName}`.trim();
}
